import { PRICE_RANGES } from './priceRanges';

export const LOW_STOCK_LIMITS = {
  [PRICE_RANGES.HIGH]: 5,
  [PRICE_RANGES.MID]: 10,
  [PRICE_RANGES.LOW]: 15,
} as const;

export const IN_STOCK = 'in-stock';
export const LOW_STOCK = 'last-pieces-items-left';
export const OUT_OF_STOCK = 'out-of-stock';
export const SOLD_OUT = 'Sold out';
export const AVAILABLE_SOON = 'available-soon';

export type LowStockLimits = ValueOf<typeof LOW_STOCK_LIMITS>;
